<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate (ngSubmit)="save(partsForm.value)" [formGroup]="partsForm">
    <div class="ir-modal--title">
      <!-- <div class="ir-line--right">
        <div class="ir-btn th-btn-modal" (click)="openMenu()">
          <i class="material-icons">more_vert</i>
        </div>
      </div> -->
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'plugins.parts.add-part' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--header">
            <td class="th-plugin-line--data">
              <span>N°</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.pages' | translate }}</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.position' | translate }}</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.parts-name' | translate }}</span>
            </td>
            <td *ngIf="!partId" class="th-plugin-line--data">
              <span>{{ 'plugins.parts.quantity' | translate }}</span>
            </td>
            <td *ngIf="!partId" class="th-plugin-line--data" colspan="2">
              <span>{{ 'plugins.parts.add-remove' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" formArrayName="parts" *ngFor="let part of formData.controls; let i = index">
            <td [formGroupName]="i">
              <input
                type="text"
                class="ir-form-set"
                formControlName="id"
                (input)="partsForm.controls.parts.controls[i].controls.id.setValue(trimPartId($event.target.value), { emitEvent: false })"
              />
              <validation-message
                [validationControl]="partsForm.controls.parts.controls[i].controls.id"
                [validationName]="'required'"
                [errorMessage]="'common.required' | translate"
              ></validation-message>
            </td>
            <td [formGroupName]="i">
              <input type="text" class="ir-form-set" formControlName="page" />
              <validation-message
                [validationControl]="partsForm.controls.parts.controls[i].controls.page"
                [validationName]="'required'"
                [errorMessage]="'common.required' | translate"
              ></validation-message>
            </td>
            <td [formGroupName]="i">
              <input type="text" class="ir-form-set" formControlName="position" />
              <validation-message
                [validationControl]="partsForm.controls.parts.controls[i].controls.position"
                [validationName]="'required'"
                [errorMessage]="'common.required' | translate"
              ></validation-message>
            </td>
            <td [formGroupName]="i">
              <input type="text" class="ir-form-set" formControlName="partsName" />
              <validation-message
                [validationControl]="partsForm.controls.parts.controls[i].controls.partsName"
                [validationName]="'required'"
                [errorMessage]="'common.required' | translate"
              ></validation-message>
            </td>
            <td *ngIf="!partId" [formGroupName]="i">
              <input type="number" class="ir-form-set" formControlName="quantity" min="1" />
              <validation-message
                [validationControl]="partsForm.controls.parts.controls[i].controls.quantity"
                [validationName]="'required'"
                [errorMessage]="'common.required' | translate"
              ></validation-message>
              <validation-message
                [validationControl]="partsForm.controls.parts.controls[i].controls.quantity"
                [validationName]="'min'"
                [errorMessage]="'common.min1' | translate"
              ></validation-message>
            </td>
            <td *ngIf="!partId" class="th-plugin-line--numbers">
              <i class="material-icons" *ngIf="part.controls.quantity.value > 0" (click)="updateQuantity(part.controls.quantity, -1)"
                >remove_circle</i
              >
              <i class="material-icons th-disabled" *ngIf="part.controls.quantity.value == 0">remove_circle</i>
              <i class="material-icons" (click)="updateQuantity(part.controls.quantity, 1)">add_circle</i>
            </td>
            <td *ngIf="!partId" class="th-plugin-line--remove">
              <i class="material-icons" (click)="remove(i)">remove_circle</i>
            </td>
          </tr>
          <tr *ngIf="!partId && equipmentId" class="th-plugin-line--add">
            <td colspan="8">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="!partsForm.valid"
            *ngIf="!processing && !partId"
          >
            <span>{{ 'common.add' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="!partsForm.valid"
            *ngIf="!processing && !!partId"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<modal (modalOutput)="selectMenu($event)"></modal>
